export const RESTORE_SPEED = {
    low: 1,
    middle: 2,
    high: 3,
    highest: 4,
};

// 过滤CDP相关LUN
export const LUN_RSSTYPE = {
    hasCreatedCDP: 42,
    canBeCreatedCDP: 43,
};

// 过滤CDP相关PG
export const PG_RSSTYPE = {
    cdpCreated: 23,
};

export const DEFAULT_CDP_SCHEDULE_NAME = 'NAS_DEFAULT_BUILDIN';

// 系统LUN类型
export const SYSTEM_LUN_TYPE = '6';

// 系统LUN名称
export const SYSTEM_LUN_NAMES = ['SYS_LUN_1', 'SYS_LUN_2', 'SYS_LUN_3'];
